import { createSlice } from '@reduxjs/toolkit';

import { addStateFetch } from '@webapp/account/src/resources/store-utils';

import { changeCampaignTitle, deleteCampaign, getCampaignList, getDataPoints, getUserWalletBalance } from './async';
import { initialState } from './state';

export const respondentsSlice = createSlice({
    name: 'respondents',
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        addStateFetch(
            builder
                .addCase(getUserWalletBalance.fulfilled, (s, { payload }) => {
                    s.walletBalance = payload;
                })
                .addCase(getDataPoints.fulfilled, (s, { payload: { categories, dataPoints } }) => {
                    s.dataPoints = {
                        categories: Object.values(categories),
                        points: dataPoints,
                        isDataPointsLoaded: true,
                    };
                })
                .addCase(getCampaignList.fulfilled, (s, { payload }) => {
                    s.campaigns = payload.map((item) => ({
                        id: item.ID,
                        title: item.TITLE || item.campaignData?.title,
                        userId: item.USER_ID,
                        surveyId: item.SURVEY_ID,
                        externalId: item.EXTERNAL_ID,
                        redirectLink: item.REDIRECT_LINK,
                        campaignData: item.campaignData,
                    }));
                    s.isCampaignsLoaded = true;
                })
                .addCase(getCampaignList.pending, (state, { meta: { arg } }) => {
                    if (arg.firstLoad) {
                        state.isCampaignsLoaded = false;
                    }
                })
                .addCase(deleteCampaign.fulfilled, (state, { payload: { campaignId } }) => {
                    state.campaigns = state.campaigns.filter((item) => item.id !== campaignId);
                })
                .addCase(changeCampaignTitle.fulfilled, (state, { payload: { campaignId, title } }) => {
                    state.campaigns = state.campaigns.map((item) =>
                        item.id === campaignId ? { ...item, title } : item,
                    );
                }),
        ),
});
